/**
 * WELT-01b (Okt 2026) – Anzeige „X von Y eigenen Welten genutzt".
 *
 * Reine Anzeige der serverseitigen Wahrheit (GET /api/courses/world-quota).
 * Trifft KEINE Sicherheitsentscheidung. Für ausgenommene Mandanten (Master,
 * Sandbox, DEMO, Pilot ohne Lizenz) liefert das Backend `exempt=true` bzw.
 * `limit=null` → die Komponente rendert dann bewusst NICHTS.
 */
import { Layers } from "lucide-react";

export function WorldQuotaBadge({ quota }) {
  if (!quota || quota.exempt || quota.limit == null) return null;
  const used = Number(quota.used ?? 0);
  const limit = Number(quota.limit);
  const atLimit = used >= limit;
  return (
    <div
      data-testid="world-quota-indicator"
      data-quota-used={used}
      data-quota-limit={limit}
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-sm ${
        atLimit
          ? "border-amber-300 bg-amber-50 text-amber-800"
          : "border-slate-200 bg-slate-50 text-slate-600"
      }`}
    >
      <Layers className="w-4 h-4 shrink-0" />
      <span>
        <strong>{used}</strong> von <strong>{limit}</strong> eigenen Welten genutzt
      </span>
    </div>
  );
}

export default WorldQuotaBadge;
